<div class="customer_list">
    <div class="table_container">
        <table [dataSource]="dataSource" mat-table>
            <form [formGroup]="searchForm">
                <!-- actions Column -->
                <ng-container matColumnDef="actions" stickyEnd>
                    <th *matHeaderCellDef class="actions-cell" mat-header-cell>
                        <div class="field_sec">
                            <div class="search" (click)="searchData()">
                                <mat-icon>search</mat-icon>
                            </div>
                        </div>
                        <h3>
                            Actions
                        </h3>
    
                    </th>
                    <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
                        <button type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu"
                            (click)="$event.stopPropagation()">
                            <mat-icon>more_horiz</mat-icon>
                        </button>
                        <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                            <button mat-menu-item (click)="OpenChangeStatusModal(row)">
                                <span>Change Status</span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="field_sec">
                            <input type="text" placeholder="Name" formControlName="name" />
    
                        </div>
                        <h3 mat-sort-header>
                            Name
                        </h3>
    
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.name}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="mobileNumber">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="field_sec">
                            <input type="text" placeholder="Mobile Number" formControlName="mobileNumber" />
    
                        </div>
                        <h3 mat-sort-header>
                            Mobile Number
                        </h3>
    
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.mobileNumber | mask : "(000) 000-0000"}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="emailAddress">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="field_sec">
                            <input type="text" placeholder="Email Address" formControlName="emailAddress" />
    
                        </div>
                        <h3 mat-sort-header>
                            Email Address
                        </h3>
    
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.emailAddress}}
                    </td>
                </ng-container>
              
                <ng-container matColumnDef="department">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="field_sec">
                            <input type="text" placeholder="Department" formControlName="department" />
    
                        </div>
                        <h3 mat-sort-header>
                            Department
                        </h3>
    
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.department}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="field_sec">
                            <input type="text" placeholder="Status" formControlName="status" />
    
                        </div>
                        <h3 mat-sort-header>
                            Status
                        </h3>
    
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.status}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="zipCode">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="field_sec">
                            <input type="text" placeholder="Zip Code" maxlength="5" formControlName="zipCode"
                                (keypress)="apiService.allowNumbers($event)" />
    
                        </div>
                        <h3 mat-sort-header>
                            Zip Code
                        </h3>
    
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element?.zipCode}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="message">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="field_sec">
                            <input type="text" placeholder="Message" formControlName="message" />
    
                        </div>
                        <h3 mat-sort-header>
                            Message
                        </h3>
    
                    </th>
                    <td mat-cell *matCellDef="let element" >
                     <div class="maxTxt" matTooltip="{{element?.message}}" [matTooltipShowDelay]="300">
                        {{element?.message}}
                     </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="visibleColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: visibleColumns" class="clickable route-animations-elements" >
                </tr>
            </form>
        </table>
    </div>
    
</div>

<div *ngIf="itemList?.length === 0" style="padding: 10px 0; text-align:center;">
    No User found.
</div>